export default "__VITE_ASSET__CehzV7Kb__"